import MissionsAPI from '~/services/api/MissionsAPI';
import MissionMediasAPI from '~/services/api/MissionMediasAPI';
import OrganizationsAPI from '~/services/api/OrganizationsAPI';
import OperatorApplicationAPI from '~/services/api/OperatorApplicationAPI';
import SkillsAPI from '~/services/api/SkillsAPI';
import UserAPI from '~/services/api/UserAPI';

export default (ctx) => {
  ctx.$axios.defaults.baseURL = ctx.$config.ocusApiUrl;
  UserAPI.init(ctx.$axios);
  MissionsAPI.init(ctx.$axios);
  MissionMediasAPI.init(ctx.$axios);
  OrganizationsAPI.init(ctx.$axios, ctx.$config);
  OperatorApplicationAPI.init(ctx.$axios);
  SkillsAPI.init(ctx.$axios);
};
